import { COOKIE_DOMAIN } from '../config.js';

// Suppression only — nothing writes auth cookies anymore. The attribute is
// `max-age`: the camelCase `maxAge` this file used before is ignored by
// browsers, so the legacy cookie was never actually deleted (the same bug
// Gallery fixed in its PR #80). Expired across every scope it could live in.
const expire = (name, attributes = '') => {
  document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=-1${attributes}`;
};

export const removeCookie = (name) => {
  expire(name, `; domain=${COOKIE_DOMAIN}`);
  expire(name, `; domain=${window.location.hostname}`);
  expire(name);
};
